module.exports = __webpack_public_path__ + "static/media/Renovation-Entreprise-Vaud.cebef66e.jpg";